import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Loader2, Building2, ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Bundles() {
  const { data, isLoading } = useQuery({
    queryKey: ["bundles"],
    queryFn: async () => (await api.get("/bundles")).data,
  });
  const bundles = data?.bundles || [];

  return (
    <div className="space-y-6" data-testid="bundles-page">
      <div>
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground mb-1">Placement Prep</p>
        <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tighter">Company Mock Tests</h1>
        <p className="text-muted-foreground mt-1">Ready-made mock tests modeled on real company placement patterns. Start in one click.</p>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-24"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {bundles.map((b) => (
            <div key={b.id} className="rounded-md border border-border bg-card overflow-hidden flex flex-col hover:-translate-y-1 transition-transform" data-testid={`bundle-${b.id}`}>
              <div className="h-2" style={{ background: b.accent }} />
              <div className="p-6 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-11 h-11 rounded-md flex items-center justify-center" style={{ background: `${b.accent}20` }}>
                    <Building2 className="w-6 h-6" style={{ color: b.accent }} />
                  </div>
                  <h3 className="font-heading font-black text-2xl tracking-tight">{b.company}</h3>
                </div>
                <p className="text-sm text-muted-foreground mb-4">{b.description}</p>
                <div className="space-y-2 mb-6 flex-1">
                  {b.sections?.map((s) => (
                    <div key={s} className="flex items-center gap-2 text-sm">
                      <CheckCircle2 className="w-4 h-4 text-success shrink-0" />
                      <span>{s}</span>
                    </div>
                  ))}
                </div>
                <Link to={`/quizzes/${b.quiz_id}`} state={{ bundle: b }}>
                  <Button className="w-full rounded-md gap-2" data-testid={`start-bundle-${b.id}`}>
                    Start Mock Test <ArrowRight className="w-4 h-4" />
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
